import React, { useEffect } from 'react';
import './Disclaimer.css';

const Disclaimer = () => {
  // Signal to react-snap that this page has been rendered
  useEffect(() => {
    if (typeof window !== 'undefined' && window.document) {
      document.documentElement.setAttribute('data-prerendered', 'true');
      // Add a marker element that react-snap can detect
      const marker = document.createElement('div');
      marker.id = 'disclaimer-content-loaded';
      marker.style.display = 'none';
      document.body.appendChild(marker);
    }
  }, []);

  return (
    <div className="disclaimer-container">
      <noscript>
        <div className="noscript-legal-content">
          <h2>OriginSelect Disclaimer</h2>
          <p><strong>Privacy Contact:</strong> For any privacy-related inquiries, please contact our privacy officer at: <a href="mailto:admin@originselect.com">admin@originselect.com</a></p>
          <p>Please enable JavaScript to view the full interactive page.</p>
          <hr/>
          <p>Last updated: May 12, 2025</p>
        </div>
      </noscript>
      <h4 className="disclaimer-title">Legal Disclaimer</h4>
      <div className="disclaimer-content">
        <p>
          <strong>Product Information:</strong> The products displayed on this website are third-party products. 
          OriginSelect is not liable for the quality, availability, or accuracy of information about these products. 
          Store websites are the correct source for current pricing and detailed product information.
        </p>
        
        <p>
          <strong>No Warranties:</strong> All information on this website is provided "as is" without warranty of any kind, 
          either express or implied, including but not limited to fitness for a particular purpose, or non-infringement.
        </p>
        
        <p>
          <strong>External Links:</strong> This website may contain links to external websites that are not provided or maintained by 
          or in any way affiliated with OriginSelect. We do not guarantee the accuracy, relevance, timeliness, or completeness of 
          any information on these external websites.
        </p>
        
        <p>
          <strong>Pricing and Availability:</strong> Product pricing and availability information shown on OriginSelect is subject to change. 
          The availability information and price displayed on the original retailer's website at the time of purchase will apply.
        </p>
        
        <p>
          <strong>Copyright:</strong> All content including images, text, and design is the property of their respective owners 
          and protected by copyright laws.
        </p>

        <h4>User Obligations</h4>
        <p>
          By using this website, you agree to not misuse the service or help anyone else to do so. You agree not to probe, scan, or test the vulnerability of any system or network. You agree not to breach or otherwise circumvent any security or authentication measures. You agree not to access, tamper with, or use non-public areas or parts of the Services, or shared areas of the Services you haven't been invited to.
        </p>

        <h4>Governing Law</h4>
        <p>
          These terms and conditions are governed by and construed in accordance with the laws of the Province of Ontario and the laws of Canada applicable therein. You irrevocably submit to the exclusive jurisdiction of the courts in that Province or location.
        </p>

        <h4>Privacy Inquiries</h4>
        <p>
          For any privacy-related inquiries or concerns about this disclaimer, please contact our privacy officer at: <a href="mailto:admin@originselect.com">admin@originselect.com</a>
        </p>
      </div>
      <p className="disclaimer-footer">Last updated: May 12, 2025</p>
    </div>
  );
};

export default Disclaimer;